/**
 * Created by coolguy on 2017/4/15.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
 ajaxCommon
} = Ajax;
const TheApi = API('im');

//actions
const IM_LOGIN = "IM_LOGIN";//登录
const IM_LOGOUT = "IM_LOGOUT";//登出
const IM_INIT = "IM_INIT";
const IM_GROUP_INFO = "IM_GROUP_INFO";
const IM_GROUP_LIST = "IM_GROUP_LIST";
const IM_GROUP_MESSAGE = "IM_GROUP_MESSAGE";
const IM_WITHDRAW = "IM_WITHDRAW";
const IM_GROUP_UPDATE = "IM_GROUP_UPDATE";

let imAction = {
    IM_WITHDRAW,
    imWithdraw:(groupid, seqid)=>{
        return ajaxCommon({
            api:TheApi('post')('withdraw'),
            data:{
                groupid,
                ids:seqid
            },
            success: (data)=>({
                type:IM_LOGOUT,
                data
            })
        })
    },
    IM_GROUP_INFO,
    imGroupInfo:(groupid)=>{
        return (dispatch)=>{
            return new Promise((resolve)=>{
                var result = {};
                result.type = IM_GROUP_INFO;

                window.webim.getGroupInfo({
                    'GroupIdList': [
                        groupid
                    ],
                    'GroupBaseInfoFilter': [
                        'Type',
                        'Name',
                        'Introduction',
                        'Notification',
                        'Owner_Account',
                        'LastInfoTime',
                        'LastMsgTime',
                        'NextMsgSeq',
                    ],
                    'MemberInfoFilter': []
                }, (resp)=>{
                    if(resp && resp.ActionStatus == 'OK') {
                        result.data = resp.GroupInfo;
                    }
                    resolve(result.data);
                    dispatch(result);
                }, (err)=>{
                    resolve(result.data);
                    dispatch(result);
                });
            });
        }
    },
    IM_GROUP_MESSAGE,
    imGroupMessage:(groupId, seq)=>{
        return (dispatch)=>{
            return new Promise((resolve)=>{
                var result = {};
                result.type = IM_GROUP_MESSAGE;
                // if(seq > 0) {
                  let promise = window.tim.getMessageList({
                    conversationID:'GROUP' + groupId,
                    nextReqMessageID:seq || 0,
                    count:100
                  });
                  
                  if(promise) {
                    promise.then(imResponse=>{
                      const messageList = imResponse.data.messageList; // 消息列表。
                      const nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
                      const isCompleted = imResponse.data.isCompleted;

                      // 设置已读
                      window.tim.setMessageRead({
                        conversationID:'GROUP' + groupId
                      });

                      result.data = messageList;
                      result.nextReqMessageID = nextReqMessageID;
                      result.isCompleted = isCompleted;

                      resolve(result);
                      dispatch(result);
                    }).catch(e=>{
                      console.log('message list error', e);
                    });
                  }else {
                    result.data = [];
                    result.isCompleted = true;
                    result.nextReqMessageID = 0;
                    resolve(result);
                    dispatch(result);
                  }
                    // window.webim.syncGroupMsgs({
                    //     GroupId:groupId,
                    //     ReqMsgSeq:seq - 1,
                    //     ReqMsgNumber:100,
                    //     'GroupBaseInfoFilter': [
                    //         'Name',
                    //         'Introduction',
                    //         'LastMsgTime',
                    //         'NextMsgSeq',
                    //         'MemberNum'
                    //     ],
                    // },
                    // function(resp) {
                    //     result.data = resp || [];
                    //     console.log(resp);
                    //     resolve(result);
                    //     dispatch(result);
                    // },
                    // function(err) {
                    //     result.data = [];
                    //     resolve(result);
                    //     dispatch(result);
                    // });
                // }else {
                //     result.data = [];
                //     resolve(result);
                //     dispatch(result);
                // }
            })
        }
    },
    IM_GROUP_UPDATE,
    imGroupUpdate:(groupid, info)=>{
      return (dispatch)=>{
        dispatch({
          type:IM_GROUP_UPDATE,
          data:info,
          id:groupid
        });
      }
    },
    IM_GROUP_LIST,
    imGroupList:(logininfo)=>{
        return (dispatch)=>{
            return new Promise((resolve)=>{
                var result = {};
                result.type = IM_GROUP_LIST;
                console.log('starting get group list');
                window.tim.getGroupList({
                  groupProfileFilter:[
                    window.TIM.TYPES.GRP_PROFILE_INTRODUCTION
                  ]
                }).then(res=>{
                  if(res && res.code === 0) {
                    let {groupList} = res.data;
                    result.data = groupList.map(it=>{
                        try {
                            var desc = JSON.parse(it.introduction);
                            it.desc = desc.galleryid;
                            it.actionstarttime = desc.starttime;
                            it.actionendtime = desc.endtime;

                        }catch(e) {}

                        it.isCompleted = false;
                        it.lastMessageTime = (it.lastMessage && it.lastMessage.lastTime) ? it.lastMessage.lastTime : 0;
                        it.nextReqMessageID = 0;

                        return it;
                    });

                    resolve(result);
                    dispatch(result);
                  }
                })

                // window.webim.getJoinedGroupListHigh({
                //     Member_Account:logininfo,
                //     Limit:50,
                //     Offset:0,
                //     'GroupBaseInfoFilter': [
                //         'Name',
                //         'Introduction',
                //         'LastMsgTime',
                //         'NextMsgSeq',
                //         'MemberNum'
                //     ],
                // },
                // function(resp) {
                //     if(resp && resp.ErrorCode == 0) {
                //         result.data = resp.GroupIdList.map(it=>{
                //             try {
                //                 var desc = JSON.parse(it.Introduction);
                //                 it.desc = desc.galleryid;
                //                 it.actionstarttime = desc.starttime;
                //                 it.actionendtime = desc.endtime;
                //             }catch(e) {}
                //
                //             return it;
                //         });
                //     }else
                //         result.data = [];
                //
                //     resolve(result);
                //     dispatch(result);
                // },
                // function(err) {
                //     result.data = [];
                //     resolve(result);
                //     dispatch(result);
                // })
            })
        };
    },
    IM_LOGIN,
    imLogin: () => {
        return ajaxCommon({
            api:TheApi('post')('login'),
            success: (data)=>{
                return {
                    type:IM_LOGIN,
                    data,
                }
            }
        });
    },
    IM_LOGOUT,
    imLogout: ()=>{
        return ajaxCommon({
            api:TheApi('get')('logout'),
            success: (data)=>({
                type:IM_LOGOUT,
                data
            })
        })
    },
    IM_INIT,
    imInit:(config)=>{

    }
};

export default imAction;



// WEBPACK FOOTER //
// ./src/actions/IMAction.js